import { createSlice } from '@reduxjs/toolkit';
import News from '../../models/news.model';
import pageMeta from '../../models/pagemeta.model';

interface newsState {
  news: Array<News> | undefined,
  loading: boolean,
  error: any,
  meta: pageMeta | undefined
  important: Array<News> | undefined,
  tickerNews: any
}
const initialState: newsState = {
  news: undefined,
  error: undefined,
  loading: false,
  meta: undefined,
  important: undefined,
  tickerNews: undefined
}

const newsSlice = createSlice({
  name: 'news',
  initialState: initialState,
  reducers: {

    fetchNewsRequest(state) {
      state.loading = true;
    },

    fetchNewsSuccess(state, actions) {
      state.loading = false;
      state.news = actions.payload.news;
      state.meta = actions.payload.meta;
      state.important = actions?.payload?.important;
    },


    fetchNewsFail(state, actions) {
      state.loading = false;
      state.error = actions.payload;
    },

    fetchTickerNewsSuccess(state, actions) {
      state.tickerNews = actions?.payload?.news;
      state.loading = false;
    }

  }
});

export const {
  fetchNewsSuccess,
  fetchNewsFail,
  fetchNewsRequest,
  fetchTickerNewsSuccess
} = newsSlice.actions;


export default newsSlice.reducer;